import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { cookiePreference } from "core/cookie";
import { useEffectOnce } from "react-use";

export function useTrackPageView(documentTitle: string): void {
  const { trackPageView } = useMatomo();
  useEffectOnce(() => {
    if (cookiePreference("analytics")) {
      trackPageView({ documentTitle });
    }
  });
}
